module.exports = __webpack_public_path__ + "img/sintesis.7d3278db.svg";